import { SseEventBase } from './sse-event-base.model';
import { SseEventType } from './sse-event-type.model';
import { runInInjectionContext } from '@angular/core';
import { RightsNotificationTypeEnum } from '../../enums/notification/rights-notification-type.enum';
import { MessageDesignBUtils } from '../../content/components/message-design-b/message-design-b.utils';

export class SseRightsNotificationEvent extends SseEventBase {

  type: SseEventType = 'rightsNotification';
  onMessage = (event: MessageEvent<any>): void => {
    const resp = JSON.parse(event.data);

    runInInjectionContext(this.injector, () => {
      if (resp.typeEnum === RightsNotificationTypeEnum.FUNCTION_BASED_NOTIFICATION) {
        this.messageClientService.messages$.next(MessageDesignBUtils.functionBasedRightsChange());
        this.on.functionBasedRightsChanged$.next(true);
      }

      if (resp.typeEnum === RightsNotificationTypeEnum.DATA_BASED_NOTIFICATION) {
        const message = MessageDesignBUtils.dataBasedRightsChange();
        message.onActionFunction = () => {
          this.on.dataBasedRightsChanged$.next(true);
        };
        this.on.inProgressAsyncWorkFinished$.next(message);

      }

      if (resp.typeEnum === RightsNotificationTypeEnum.USER_RIGHTS_CHANGED_BY_USER_NOTIFICATION) {
        this.messageClientService.messages$.next(MessageDesignBUtils.userBasedRightsChangedByUser());
        this.on.userRightsChangedByUser$.next(true);
      }

      if (resp.typeEnum === RightsNotificationTypeEnum.USER_RIGHTS_NOTIFICATION) {
        this.on.userRightsChanged$.next(true);
      }
    });
  }
}
